import createRoute  from '@widesk-ui/tools/createRoute';
import InvoiceModel from '@models/account/InvoiceModel';

export default createRoute.dashboard('/invoices', 'account', 'InvoiceDashboard', InvoiceModel.localize());